module.exports = __webpack_public_path__ + "static/img/A.551dc50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/SuperAce/A.png
// module id = 9hbc
// module chunks = 0